// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_GatewaySettingsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_GatewaySettingsResponse — settings for one gateway provider.
 *
 * Used by:
 *   GET  /subscriptions/gateways/settings/(:any) — current settings (secret masked)
 *   POST /subscriptions/gateways/settings        — echoes the updated set (secret masked)
 *   POST /subscriptions/gateways/rotate-secret    — single-row: the new, UNMASKED webhook_secret
 *
 * Shape:
 * {
 *   "provider_code": "gatewaytest",
 *   "settings": [ { "setting_key": "never_confirm", "setting_value": "0" }, ... ]
 * }
 */
import type { Subscriptions_GatewaySettingsRow } from './Subscriptions_GatewaySettingsRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_GatewaySettingsResponseDados {
provider_code: string
settings: Subscriptions_GatewaySettingsRow[]
}

export type Subscriptions_GatewaySettingsResponse = ApiResponse<Subscriptions_GatewaySettingsResponseDados>;

registerResponseContract('Subscriptions_GatewaySettingsResponse', {
  provider_code: { type: 'string',  required: true },
  settings: {
    type: 'array',
    required: true,
    items: {
      setting_key:   { type: 'string',  required: true },
      setting_value: { type: 'string',  required: false },
    },
  },
})
